import Fields, { UserFormValues } from 'Components/users/Fields';
import { PRIVILEGE } from 'constants/privilege';
import { useFormik } from 'formik';
import withAccessControl from 'hoc/withAccessControl';
import useDocumentTitle from 'hooks/useDocumentTitle';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Card, CardBody, Col, Form, Row, Spinner } from 'reactstrap';
import { createNewUser } from 'services/api/users';
import { fetchUserBrands } from 'slices/users/brands/thunk';
import { fetchUserList } from 'slices/users/list/thunk';
import { fetchRoles } from 'slices/users/roles/thunk';
import { AppDispatch, RootState } from 'store';
import { NewUser, OWNER_ROLE_SLUG, UserRole } from 'types/users';
import { getErrorMessage } from 'utils/helpers';
import * as Yup from "yup";

const CreateUser = () => {

    useDocumentTitle("Create User");

    const selectedAgency = useSelector((state: RootState) => state.auth.selectedAgency);

    const [selectedRole, setSelectedRole] = useState<UserRole | null>(null);

    const dispatch: AppDispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const defaultFormValues: UserFormValues = {
        name: '',
        email: '',
        role: { name: 'Viewer', slug: 'viewer' },
        brands: [],
        notification_preferences: [], 
    };


    const formFields = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: defaultFormValues,
        validationSchema: Yup.object({
            name: Yup.string().required("User name field can't be empty"),
            email: Yup.string().required("User email field can't be empty").email("Please enter a valid email address"),
            // ...(selectedRole?.slug !== OWNER_ROLE_SLUG ? { brands: Yup.array().required("Brands field can't be empty").min(1, 'Assign atleast one brand') } : {}),
        }),
        onSubmit: async (values) => {
            try {
                const newUser: NewUser = {
                    ...values,
                    brands: values.role.slug === OWNER_ROLE_SLUG ? [] : values.brands.map((brand) => brand.id),
                    role: values.role.slug
                }
                setLoading(true);
                await createNewUser(selectedAgency?.uuid!, newUser);
                dispatch(fetchUserList({ page: 1, force: true }))
                toast.success("User created successfully!");
                navigate('/user');
            } catch (error) {
                toast.error(getErrorMessage(error, 'Failed to create new user'));
            } finally {
                setLoading(false)
            }
        }
    });

    useEffect(() => {
        dispatch(fetchUserBrands(false));
        dispatch(fetchRoles(false));
    }, [dispatch])

    return (
        <div className="page-content">
            <div className="page-content-inner page-spacing">
                <div className="d-flex w-100 justify-content-between align-items-center pt-1 pb-5">
                    <h4 className="page-title">Create User</h4>
                </div>
                <Form className='needs-validation' onSubmit={(e) => {
                    e.preventDefault();
                    formFields.handleSubmit();
                    return false;
                }}>
                    <Row>
                        <Col sm={12}>
                            <Card>
                                <CardBody>
                                    <Fields formFields={formFields} onRoleChange={(role) => setSelectedRole(role)} />
                                </CardBody>
                            </Card>
                            <div className="d-flex justify-content-between mb-4">
                                <Link to={{pathname: '/user'}} type='button' className="theme-btn theme-btn-lg btn-primary-outlined"><i className='bx fs-4 bx-left-arrow-alt me-2' ></i>Back</Link>

                                <button type='submit' disabled={loading} className="theme-btn theme-btn-lg btn-gradient form-continue-btn">
                                    {
                                        loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : <React.Fragment>Save <i className='bx fs-4 bx-right-arrow-alt' ></i></React.Fragment>
                                    }
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    )
}

export default withAccessControl(CreateUser, PRIVILEGE.AGENCY.USER.CREATE)